import { useEffect, useMemo, useState } from 'react'
import {
  Dropdown,
  Option,
  OptionOnSelectData,
  SelectionEvents,
} from '@fluentui/react-components'
import StatusBadge, { getStatusBadgeLabel } from '../StatusBadge'
import { usePeriodReportSnapshots } from '../fetchData/queries/usePeriodReportSnapshots'
import { usePeriodReportSelectionEffect } from '../fetchData/queries/usePeriodReportSelectionEffect'
import { useProjektprognosEditingContext } from '../context/ProjektprognosEditingContext'

const PeriodReportSelector = () => {
  const [selectedReportId, setSelectedReportId] = useState<string>('')
  const {
    isLoading,
    isFetching,
    data: periodReports,
  } = usePeriodReportSnapshots()
  const { selectedPeriodReport } = useProjektprognosEditingContext()

  // Set initial selected report
  useEffect(() => {
    // If we already have a selection, don't override it
    if (selectedReportId) return

    // Wait for data
    if (!periodReports || periodReports.length === 0) return

    // Try to find Ongoing report
    const ongoingReport = periodReports.find(
      (report) => report.status === 'Ongoing'
    )

    if (ongoingReport) {
      setSelectedReportId(ongoingReport.id)
    } else {
      setSelectedReportId(periodReports[0].id)
    }
  }, [periodReports, selectedReportId, isLoading, isFetching])

  usePeriodReportSelectionEffect(selectedReportId || null)

  const hasOngoing = useMemo(
    () => periodReports?.some((r) => r.status === 'Ongoing') ?? false,
    [periodReports]
  )
  //Todo remove when launhing
  const disableLive = useMemo(() => {
    const value = new URLSearchParams(window.location.search).get('showLive')
    if (value === null) return false

    return value === '' || value.toLowerCase() === 'true' || value === '1'
  }, [])

  const handleChange = (_event: SelectionEvents, data: OptionOnSelectData) => {
    if (data.optionValue) {
      setSelectedReportId(data.optionValue)
    }
  }

  const displayValue = selectedPeriodReport
    ? `${selectedPeriodReport.year} - ${selectedPeriodReport.reportPeriod} - ${getStatusBadgeLabel(
        selectedPeriodReport.status
      )}`
    : ''
  return (
    <Dropdown
      placeholder="Välj periodsrapport"
      value={displayValue}
      selectedOptions={selectedReportId ? [selectedReportId] : []}
      onOptionSelect={handleChange}
      disabled={isLoading}
      style={{ minWidth: '200px', margin: 10 }}
      size="small"
    >
      {periodReports?.map((report) => (
        <Option
          key={report.id}
          value={report.id}
          text={`${report.year} - ${report.reportPeriod} - ${getStatusBadgeLabel(
            report.status
          )}`}
          disabled={!disableLive && report.status === 'Open' && hasOngoing}
        >
          <>
            {`${report.year} - ${report.reportPeriod}`}
            <StatusBadge
              status={report.status}
              size="small"
              style={{ marginLeft: 8 }}
            />
          </>
        </Option>
      ))}
    </Dropdown>
  )
}

export default PeriodReportSelector
